import firebase from 'firebase/app'
import { TrialApplication } from '@/models/TrialApplication'

class TrialApplicationRepository {
  constructor(client) {
    this.collection = client.collection('trialApplications')
    this.snapShotOptions = { serverTimestamps : 'estimate' }
  }

  async put (
    values
  ) {
    const docRef = await this.collection.doc()
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const trialApplication = new TrialApplication(
      docRef.id,
      values.parentName,
      values.email,
      values.studentName,
      values.studentAge,
      values.opinion,
      timestamp,
      timestamp
    )
    const object = trialApplication.toObject()
    await docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createTrialApplicationFromFireStoreData(result.id, data)
  }
}

const createTrialApplicationFromFireStoreData = (id, data) => {
  return new TrialApplication(
    id,
    data.parentName,
    data.email,
    data.studentName,
    data.studentAge,
    data.opinion,
    data.createdAt.toDate(),
    data.updatedAt.toDate()
  )
}

export { TrialApplicationRepository }